module.exports = __webpack_public_path__ + "static/media/salao_atico_5.5ba6130c.jpg";